// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1Os2w","header":"ReportDetails_header__2g0nv","title":"ReportDetails_title__15OqY","left":"ReportDetails_left__3RngE"};